import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';

var createPalette = function createPalette(_ref) {
  var type = _ref.type,
      blue30 = _ref.blue30,
      blue500 = _ref.blue500,
      grey800 = _ref.grey800,
      grey900 = _ref.grey900,
      white = _ref.white;

  if (type === 'light') {
    return {
      defaultText: grey900,
      defaultBackground: white,
      activeBackground: blue30,
      selectedBackground: blue500,
      selectedText: white
    };
  }

  return {
    defaultText: white,
    defaultBackground: grey800,
    activeBackground: blue30,
    selectedBackground: blue500,
    selectedText: white
  };
};

var createOptions = function createOptions(_ref2) {
  var defaultText = _ref2.defaultText,
      defaultBackground = _ref2.defaultBackground,
      activeBackground = _ref2.activeBackground,
      selectedBackground = _ref2.selectedBackground,
      selectedText = _ref2.selectedText;
  return {
    "default": {
      background: defaultBackground,
      color: defaultText,
      textAlign: 'left'
    },
    active: {
      background: activeBackground
    },
    selected: {
      background: selectedBackground,
      color: selectedText
    }
  };
};

var createGetSelectable = function createGetSelectable(options) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    return options[state];
  };
};

var createSelectableStates = function createSelectableStates(options) {
  var states = {};
  var keys = Object.keys(options);

  for (var i = 0; i < keys.length; i++) {
    states[keys[i]] = keys[i];
  }

  return states;
};

export var createSelectable = function createSelectable(palette) {
  var selectable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref3 = typeof selectable === 'function' ? selectable(palette) : selectable,
      otherGetSelectable = _ref3.getSelectable,
      otherOptions = _objectWithoutProperties(_ref3, ["getSelectable"]);

  var selectablePalette = createPalette(palette);
  var options = createOptions(selectablePalette);
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getSelectable: otherGetSelectable || createGetSelectable(mergedOptions),
    selectableStates: createSelectableStates(mergedOptions)
  }, mergedOptions);
};